import useSWR from 'swr';
import useSWRMutation from 'swr/mutation';
import { useDealerActivationService } from 'hooks/services';
import { getKey, Resource } from './key';

export const useDealerActivation = ({
  enabled = true,
}: { enabled?: boolean } = {}) => {
  const { listDeletedDealers, reactivateDealer } = useDealerActivationService();

  const { data, isLoading } = useSWR(
    enabled ? getKey(Resource.DEALER_DELETED_LIST, {}) : null,
    () => listDeletedDealers(),
    { revalidateOnFocus: false },
  );

  const { trigger, isMutating } = useSWRMutation(
    getKey(Resource.DEALER_DELETED_LIST, {}),
    (_key, { arg }: { arg: { dealerId: string } }) => reactivateDealer(arg),
  );

  return {
    deletedDealers: data ?? [],
    isLoadingDeletedDealers: isLoading,
    reactivateDealer: trigger,
    isReactivating: isMutating,
  };
};
